import { priceFormatter } from '@2wunder/klarx-tool'
import { Typography } from 'antd'
import IntlStringMessages from 'app/util/IntlStringMessages'

export const RequestItemTotalPrice = ({ requestItem }: { requestItem: IProductRequestItem }) => {
  if (requestItem.quantity_estimated) {
    return <IntlStringMessages id="price.per_usage" />
  }

  if (requestItem.included) {
    return (
      <Typography.Text disabled>
        <IntlStringMessages id="rental-show-invoices-rental-free" />
      </Typography.Text>
    )
  }

  return <>{priceFormatter(Number(requestItem.total_cost_price))}</>
}
